/* eslint-disable max-classes-per-file */
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import isEmpty from 'lodash/isEmpty';
import makeQuery from 'yoda-core-components/lib/navigation/query/makeQuery';
import TokenProvider from 'yoda-core-components/lib/helpers/TokenProvider/TokenProvider';
import SlidePanel from 'yoda-account-components/lib/components/SlidePanel/SlidePanel';
import MessageBox from 'yoda-core-components/lib/components/MessageBox/MessageBox';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import get from 'lodash/get';
import Button from 'yoda-core-components/lib/components/Button';
import EmailShareList from '../EmailShareList/EmailShareList';
import MyShareListLink from '../MyShareListLink/MyShareListLink';
import ListSettings from '../NewListSettings/ListSettings';

class LocalListSettings extends ListSettings {
    render() {
        const { showDeleteModel } = this.state;
        return showDeleteModel ? this.deleteModelBox() : this.formRender();
    }
}

class MyShareSlider extends Component {
    static propTypes = {
        listId: PropTypes.string.isRequired,
        location: PropTypes.objectOf.isRequired,
        actions: PropTypes.func.isRequired,
        closeModal: PropTypes.func.isRequired,
        messagesTexts: PropTypes.objectOf(PropTypes.object),
        savedList: PropTypes.objectOf(PropTypes.object),
        shareList: PropTypes.objectOf(PropTypes.object),
        hideBackArrowCloseButton: PropTypes.bool,
        showMyShareListSlider: PropTypes.bool,
        listSettingProps: PropTypes.object,
        isProductsEmpty: PropTypes.bool,
    };

    static defaultProps = {
        messagesTexts: {},
        savedList: {},
        shareList: {},
        listSettingProps: {},
        hideBackArrowCloseButton: false,
        showMyShareListSlider: false,
        isProductsEmpty: false,
    };

    constructor(props) {
        super(props);
        const accountId = TokenProvider.get('ACCOUNT_ID');
        this.state = {
            accountId,
            listSetting: false,
            showMessage: props.isProductsEmpty,
            showEmailSentMsg: false,
        };
        this.onSend = this.onSend.bind(this);
        this.showSettings = this.showSettings.bind(this);
        this.onBackClicked = this.onBackClicked.bind(this);
    }

    static getDerivedStateFromProps(nextProps) {
        const {
            shareList: { response },
        } = nextProps;
        return {
            showEmailSentMsg: !isEmpty(response),
        };
    }

    onSend(recipients, message, copySender) {
        const { location, actions, listId } = this.props;
        const query = makeQuery(location.search);
        let accountId = '';
        if (query.token) {
            accountId = query.accountId;
        }
        const data = {
            recipients,
            message,
            copySender,
        };
        const { host } = window.location;
        actions.shareList(listId, data, host, accountId, query.token);
    }

    onBackClicked(e) {
        if (this.state.listSetting) {
            this.setState({ listSetting: false });
        } else {
            this.props.closeModal(e);
        }
    }

    getMessageBox(type, message) {
        if (type === 'warning') {
            // eslint-disable-next-line no-param-reassign
            message = (
                <div className={dt(['text-black', 'text-base'])}>
                    Change the{' '}
                    <Button buttonType="Link" onClick={this.showSettings}>
                        {message}
                    </Button>{' '}
                    to Public so your guest(s) can view this list.
                </div>
            );
        }
        return (
            <div>
                <MessageBox
                    hasClose={type !== 'warning'}
                    type={type}
                    title={message}
                    level="section"
                    onClose={this.closeMessageBox}
                    theme={dt(['lg:mt-2', '!mb-6'])}
                />
            </div>
        );
    }

    showSettings = () => {
        this.setState({ listSetting: true });
    };

    closeMessageBox = () => {
        this.props.actions.shareListReset();
        this.setState({
            showMessage: false,
        });
    };

    showProductAlertMessage = () => {
        const { showMessage } = this.state;
        return (
            showMessage &&
            this.getMessageBox('error', 'We’re sorry! You can’t email a list when it has 0 items')
        );
    };

    render() {
        const {
            messagesTexts,
            savedList,
            shareList,
            closeModal,
            location,
            listSettingProps,
        } = this.props; // Need to revise
        const sharedList = { ...messagesTexts.sharedList };
        const shareListLink = { ...messagesTexts.shareListLink };
        const { data: { isPublic, shareToken } = {} } = savedList;
        const { accountId, listSetting, showEmailSentMsg } = this.state;
        const panelTitle = listSetting ? 'Back to Share List' : 'Share List';
        const { showMessage } = this.state;
        return (
            <SlidePanel
                isOpenPanel={this.props.showMyShareListSlider}
                onClosePanel={this.onBackClicked}
                hideBackArrowCloseButton={false}
                panelTitle={panelTitle}
                onPrimaryCloseButtonClick={closeModal}
                panelTitleClassName={dt([
                    'text-medium',
                    'smMd:!text-large',
                    'font-open-sans-semibold',
                ])}
                showBackIcon={listSetting}
                isPrimaryCloseButtonRequired
            >
                {!listSetting && (
                    <div className={dt(['p-6'])}>
                        {this.showProductAlertMessage()}
                        {!isPublic &&
                            this.getMessageBox('warning', shareListLink.listSettingsLinkLabel)}
                        {showEmailSentMsg &&
                            this.getMessageBox('success', sharedList.emailSentSuccessMsg)}
                        {shareList.error &&
                            this.getMessageBox(
                                'error',
                                get(shareList.error, 'errorMessage', sharedList.defaultErrorMessage)
                            )}
                        <EmailShareList
                            send={this.onSend}
                            shareList={shareList}
                            messagesTexts={sharedList}
                            isDisabled={showMessage}
                            emailSent={showEmailSentMsg}
                            closeMessageBox={this.closeMessageBox}
                        />
                        <p
                            className={dt([
                                'w-full',
                                'text-center',
                                'border-b',
                                'border-solid',
                                'border-gray-15',
                                'my-3',
                                'mx-auto',
                                'h-0',
                            ])}
                        >
                            <span
                                data-automation-id="or_text"
                                className={dt([
                                    'bg-white',
                                    'px-2',
                                    'text-medium',
                                    'text-black',
                                    'relative',
                                    '-top-[19px]',
                                    'font-semibold',
                                ])}
                            >
                                or
                            </span>
                        </p>
                        <MyShareListLink
                            location={location}
                            isPublic={isPublic}
                            shareToken={shareToken}
                            accountId={accountId}
                            messagesTexts={shareListLink}
                        />
                    </div>
                )}
                {/* eslint-disable react/jsx-props-no-spreading */}
                {listSetting && <LocalListSettings {...listSettingProps} />}
            </SlidePanel>
        );
    }
}

export default MyShareSlider;
